import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SubGrupo } from 'src/app/Models/subgrupo/sub-grupo';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { ClaseComponent } from '../../clase/clase/clase.component';
import { Clase } from 'src/app/Models/clase/clase';
import { DataService } from 'src/app/Service/data.service';
import { SubClase } from 'src/app/Models/subclase/sub-clase';
import { SubClaseComponent } from '../../subclase/sub-clase/sub-clase.component';
import { Usuario } from 'src/app/Models/usuario/usuario';

@Component({
    selector: 'app-sub-grupo',
    templateUrl: './sub-grupo.component.html',
})
export class SubGrupoComponent implements OnInit {
    @ViewChild('btnshow', null) btnshow: ElementRef;
    @ViewChild('btnclose', null) btnclose: ElementRef;
    @ViewChild('txtfirt', null) txtfirt: ElementRef;
    @ViewChild(AlertComponent, null) alert: AlertComponent;
    @ViewChild(LoadingComponent, null) loading: LoadingComponent;
    @ViewChild(InfoComponent, null) info: InfoComponent;
    @ViewChild('mdsubclase', null) fmsubclase: SubClaseComponent;
    @ViewChild('mdclase', null) fmclase: ClaseComponent;
    public isShow: boolean = false;
    public pagina: number = 0;
    public clases: Clase[] =[];
    public subclases: SubClase[] = [];
    public subgrupos: SubGrupo[] = [];
    public subgrupo: SubGrupo = new SubGrupo();
    public isEdit: boolean = false;
    public funcion: Function = null;
    public pagsubgrupo: any;
    public adddescripcion: boolean = false;
    public search = '';
    public modal="";
    public total:number=0;
    public showdelete:boolean = false;
    public usuario:Usuario= new Usuario();
    public waitsubclase:boolean = false;
    public zindex:number = 10000;
    public clase:any
    constructor(private data: DataService) { }

    ngOnInit() {
    }

    public show(affterfunction: Function = null) {
        this.funcion = affterfunction;
        this.isShow = true;
        this.showTab(1);
        this.showdelete=false;
        setTimeout(async() => {
            this.btnshow.nativeElement.click();
            this.info.hide();
            this.usuario = this.data.getCurrentUser();
            
            this.GetData();
        }, 10);
    }

    GetData() {
        this.loading.show("cargando..");
        this.subgrupos=[];
        let send;

        this.data.Exists(this.search)?
        send = this.data.GetFromValue(this.data.api.subgrupo, 'like', this.search):
        send = this.data.GetSimple(this.data.api.subgrupo)

        send.subscribe(r => {
            this.loading.hide();
            if (r.length>0) { this.subgrupos = r; this.total = this.subgrupos.length;}
        }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(1) }) })
    }
    ShowInfoItem(i){
        this.subgrupo = i as SubGrupo;
        this.showTab(3);
    }
    async ShowNewItem() {
        this.isEdit = false;
        this.showTab(2);
        this.subgrupo = new SubGrupo();
        this.adddescripcion = false;
        setTimeout(() => { this.txtfirt.nativeElement.focus(); }, 10);
        await this.GetClase();
    }
    async ShowEditItem(i) {
        this.isEdit = true;
        this.showTab(2);
        this.subgrupo = i as SubGrupo;
        await this.GetClase();
        setTimeout(() => { this.txtfirt.nativeElement.focus();  }, 10);
    }
    ShowDeleteItem(i){
        this.subgrupo = i as SubGrupo;
        this.modal='';
        this.showdelete= true;
        this.info.show("¿Estimado usuario(a) deseas Quitar/Eliminar el elemento [nombre:\""+this.subgrupo.nombre+"\"] del sistema? ",1,null,{ cancelText: 'No, Cancelar', successText: 'Si, Continuar', isCancel: true },()=>{this.Delete();},()=>{this.showTab(1); this.modal='modal-lg'; this.showdelete=false; this.info.hide();},20);
    }
    ValidateControl():boolean{
        return (this.subgrupo.nombre != '' && this.subgrupo.nombre != undefined ) && (this.subgrupo.idclase.idsubcla != '' && this.subgrupo.idclase.idsubcla != undefined ) ? true : false;
    }
    Delete(){
        this.loading.show('eliminando elemento');
        this.data.delete(this.data.api.subgrupo,this.subgrupo.idgrupo).subscribe(r=>{
            this.loading.hide();
            this.info.show(r.message, r.status=='success'?1:0,null,null,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});
            if(r.status == 'success') { this.GetData();}
        },e=>{this.info.error(e.error.text,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});})
    }

    showTab(i) {
        this.pagina = i;
        if(this.pagina == 1){this.modal ='modal-lg';}
        else{this.modal='';}
    }

    close() {
        this.btnclose.nativeElement.click();
        setTimeout(() => { this.isShow=false; }, 1000);
        setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
    }
    async GetClase(){
        //this.wai=true;
        await this.data.AsyncGetSimple(this.data.api.clase).then(r=>{
            this.clases = r;
            //this.waitsubclase=false;
            console.log(this.clases);
        }).catch(e=>{console.log(e.error);});
        await this.GetSubClase();
    }
    async GetSubClase(){
        this.waitsubclase=true;
        let id = this.clase != undefined ? this.clase : '0';
        await this.data.AsyncGetFromValue(this.data.api.subclase,'idclase',id).then(r=>{
            this.subclases = r;
            console.log(this.subclases);
            this.waitsubclase=false;
        }).catch(e=>{console.log(e.error);});
    }

    ShowSubClase(){
        this.fmsubclase.show(()=>{this.GetSubClase(); this.funcion();});
    }
    ShowClase(){
        this.fmclase.show(()=>{this.GetClase(); this.funcion();});
    }
    Save() {
        if (this.isEdit) {
            this.loading.show("Actualizando..");
            this.subgrupo.usuario_id = this.data.getCurrentUser().id;
            let data:SubGrupo = new SubGrupo()
            data.idclase=this.subgrupo.idclase
            data.idgrupo=this.subgrupo.idgrupo,
            data.inventario=this.subgrupo.inventario,
            data.nombre=this.subgrupo.nombre
            this.data.Put(this.data.api.subgrupo, this.subgrupo.idgrupo, data.getData()).subscribe(r => {
                this.loading.hide();
                this.info.show(r.message, 2, null, null, () => { this.showTab(r.status == 'success' ? 1 : 2); setTimeout(() => { this.GetData(); }, 5); });
            }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(2) }) })
        }
        else {
            this.loading.show("Registrando..");
            this.subgrupo.usuario_id = this.data.getCurrentUser().id;
            console.log(this.subgrupo.getData());
            
            this.data.Post(this.data.api.subgrupo, this.subgrupo.getData()).subscribe(r => {
                this.loading.hide();
                this.info.show(r.message, 2, null, null, () => { this.showTab(r.status == 'success' ? 1 : 2); setTimeout(() => { this.GetData(); }, 5); });
            }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(2) }) })
        }
        if (this.funcion != null) {
            this.funcion();
        }
    }

}
